export const config = {
	btn: {
		height: 'auto',
		minHeight: '40px',
		activeClass: 'white--text',
		class: 'text-wrap text-left py-2'
	},
	icon: {
		class: 'white--text flex-shrink-0 ml-1'
	}
};
